// services/transactionDetailsService.js
import apiClient from '../api';

export const transactionDetailsService = {
  /**
   * Récupère les transactions d'un titre privé
   */
  getTransactions: async (securityId, domainId, filters = {}) => {
    const params = new URLSearchParams();
    
    // Filtres de base
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.transactionType) params.append('transactionType', filters.transactionType);
    if (filters.clientSearch) params.append('clientSearch', filters.clientSearch);
    
    // Pagination
    params.append('page', filters.page || 1);
    params.append('pageSize', filters.pageSize || 20);
    
    // Tri
    params.append('sortBy', filters.sortBy || 'date');
    params.append('sortDesc', filters.sortDesc ?? true);
    
    const response = await apiClient.get(
      `/api/TransactionDetail/security/${securityId}/domain/${domainId}?${params.toString()}`
    );
    
    return response.data;
  },

  /**
   * Récupère les documents d'une transaction spécifique
   * À utiliser si l'endpoint devient disponible
   */
  getTransactionDocuments: async (transactionReference) => {
    try {
      const response = await apiClient.get(
        `/api/TransactionDetail/documents/preview/${transactionReference}`
      );
      return response.data;
    } catch (error) {
      // console.warn('Documents endpoint non disponible:', error);
      return { success: true, message: "Les documents sont inclus dans la réponse principale" };
    }
  }
};